import { i18n } from "translate/i18n";

export const loading = i18n.t("messages.loading");
